import React from "react";
import { Button, Card, Table } from "antd";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import FileUploadButton from "../lib/common/FileUploadButton";
import { useAPI } from "../lib/hook/APIProvider";
import DataCompareModal from "./DataCompareModal";
import { useModal } from "../lib/modal/ModalContext";
import DownloadOutlined from "@ant-design/icons/DownloadOutlined";
import UploadOutlined from "@ant-design/icons/UploadOutlined";

const HsCodeUpdateForVehicleItem: React.FC = () => {

  const [isLoading, setIsLoading] = React.useState(false);

  
  const { client } = useAPI();
  const { hideModal, showModal } = useModal();
  const handleDownloadExcelTemplate = async () => {
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet("ImpVehiclePartHSHistory");
    ws.columns = [
      { header: "ITEM_CD", key: "ITEM_CD", width: 16 },
      { header: "CUST_CD", key: "CUST_CD", width: 16 },
      { header: "hs", key: "hs", width: 12 },
      { header: "oldhs", key: "oldhs", width: 12 },
      { header: "CONF_REASON", key: "CONF_REASON", width: 24 },
    ];

    const buf = await wb.xlsx.writeBuffer();
    saveAs(new Blob([buf]), `차량 품목 일괄 세번 변경.xlsx`);
  };

  const OnTryModifiyData = async (file: File) => {
    if (!file) {
      alert("엑셀 파일을 업로드해주세요!");
      return;
    }
    setIsLoading(true);

    const wb = new ExcelJS.Workbook();
    const reader = new FileReader();
    const rows: any[] = [];
    reader.onload = async (e) => {
      try {
        const buffer = e.target?.result as ArrayBuffer;
        await wb.xlsx.load(buffer);

        const ws = wb.worksheets[0];
        const headers: string[] = ws.getRow(1).values as string[];

        ws.eachRow((row, rowNumber) => {
          if (rowNumber === 1) return;
          const rowData: Record<string, any> = {};
          row.eachCell((cell, colNumber) => {
            const header = headers[colNumber];
            if (header) {
              rowData[header] = cell.value?.toString();
            }
          });
          rows.push(rowData);
        });

        if (
          !window.confirm(
            `찾는 값의 기준 열은: ${headers[1]} \n일괄변환 할 기준 열은: ${headers[2]} \n\n진행하시겠습니까?`
          )
        ) {
          window.alert("작업이 취소되었습니다.");
          setIsLoading(false);
          return;
        }

        const requestData = structuredClone(rows);

        const result = await client.post(
          `/preview/tcms/changeHSs?isPreview=true`,
          requestData,
          { timeout: 0 }
        );
        console.log(result.data);
        showModal(
          <>
           <DataCompareModal
              onApplyData={async () => {
              try {
                const result2 = await client.post(
                  `/preview/tcms/changeHSs?isPreview=false`,
                  requestData,
                  { timeout: 0 }
                );
                 hideModal();
               } catch (err) {
            
               } finally {
                setIsLoading(false);
                window.location.reload();
               }
              }}
              
              before={result.data.before}
              after={result.data.after}
              history={result.data.history}
            />

            
       
          </>
         
        );
      } catch (err) {
        console.error(err);
        window.alert("파일을 처리하는 중 오류가 발생했습니다.");
        setIsLoading(false);
      }
    };

    reader.readAsArrayBuffer(file);
  };



  return (
    <div className="flex flex-col h-screen w-full bg-gray-300 overflow-y-clip">
      <div className="min-h-screen flex justify-center items-center bg-gray-100">
        <div style={{ display: "flex", flexDirection: "column", gap: 32 }}>
          차량 품목 일괄 세번 변경
          <Card title="서식 다운로드" style={{ width: 400 }}>
            <Button
              icon={<DownloadOutlined />}
              className="ant-btn ant-btn-default"
              onClick={handleDownloadExcelTemplate}
            >
              엑셀 템플릿 다운로드
            </Button>
          </Card>
          <Card title="엑셀로 일괄 작업" style={{ width: 400 }}>
            <FileUploadButton onFileSelect={OnTryModifiyData}>
              <Button
                loading={isLoading}
                icon={<UploadOutlined />}
                className="ant-btn ant-btn-default"
              >
                {" "}
                일괄 작업 생성
              </Button>
            </FileUploadButton>
          </Card>
        </div>
      </div>{" "}
    </div>
  );
};

export default HsCodeUpdateForVehicleItem;
